import Layout from "../components/Layout";
import MetaBalls from '../components/MetaBalls';

const Home = () => {
  return (
    <Layout>
      {/* Hero */}
<section className="hero hero-overlay">
  <div className="hero-visuals">
    <MetaBalls
      color="#FF7200"
      cursorBallColor="#FFBC38"
      cursorBallSize={3}
      ballCount={30}
      animationSize={30}
      enableMouseInteraction={true}
      enableTransparency={true}
      hoverSmoothness={0.05}
      clumpFactor={1.2}
      speed={0.2}
      opacity={0.5}
    />
  </div>
  <div className="hero-content">
    <img
      src="/assets/images/Tearabyte-Software-Solutions.png"
      alt="Tearabyte Software Solutions"
      className="hero-title-image"
    />
    <h1>Empowering Your Business with Cutting-Edge Software</h1>
  </div>
</section>



      {/* Ethos */}
      <section className="ethos fade-in-up">
        <h2>Bridging the Tech Divide for Small Businesses</h2>
        <p>
          At TearabyteSS, we believe in leveling the playing field. Small businesses are the backbone of our economy and deserve access to cutting-edge technology. We specialise in crafting customised tech solutions tailored to meet the unique demands of your business-whether it’s a dynamic website, user-friendly internal software, or an advanced automated customer service system.
        </p>
        <p className="ethosText"><strong>Partner with TearabyteSS and empower your business to thrive in the digital age.</strong></p>
      </section>

      {/* <h2 class="services-heading">Our Services</h2> */}
      {/* Services */}
      <section className="services fade-in-up">
        <a className="card" href="/web">
          <h3>Web Development</h3>
          <p>
            Transform your digital footprint with a bespoke website that captures your brand and turns visitors into customers.
          </p>
        </a>
        <a className="card" href="/AI">
          <h3>Artificial Intelligence</h3>
          <p>
            Unleash the potential of AI to extract insights, automate interactions, and predict trends.
          </p>
        </a>
        <a className="card" href="/dataAnalytics">
          <h3>Data Analytics</h3>
          <p>
            Decode your data with tailored analytics dashboards that drive proactive decisions.
          </p>
        </a>
        {/* <a className="card" href="/backend">
          <h3>Back-end Software</h3>
          <p>
            Automate operations and access pivotal data effortlessly with powerful back-end tools.
          </p>
        </a> */}
      </section>

      {/* CTA */}
      <section className="contact-cta fade-in-up">
        <h2>
          Unlock your business’s full potential. Contact us today for a free consultation!
        </h2>
        <a className="contactLink" href="/contact">
          Contact Us
        </a>
      </section>
    </Layout>
  );
};

export default Home;
